import React, { useState } from 'react';
import axios from 'axios';
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';
import toast from 'react-hot-toast';
import './Contact.css';

function Contact() {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        subject: '',
        message: ''
    });
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        
        try {
            const response = await axios.post(`${process.env.REACT_APP_API_URL}/contact`, formData);
            toast.success(response.data.message || 'پیام شما با موفقیت ارسال شد');
            setFormData({ name: '', email: '', subject: '', message: '' });
        } catch (error) {
            console.error(error);
            toast.error(error.response?.data?.message || 'خطا در ارسال پیام');
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <Navbar />
            <div className="contact-container">
                <div className="container">
                    <div className="contact-header">
                        <h1>📧 تماس با ما</h1>
                        <p>نظرات، پیشنهادات و سوالات خود را با ما در میان بگذارید</p>
                    </div>
                    
                    <div className="contact-grid">
                        {/* فرم تماس */}
                        <div className="contact-form-card">
                            <h3>ارسال پیام</h3>
                            <form onSubmit={handleSubmit}>
                                <div className="form-group">
                                    <label>نام و نام خانوادگی *</label>
                                    <input 
                                        type="text" 
                                        name="name" 
                                        value={formData.name}
                                        onChange={handleChange}
                                        required 
                                    />
                                </div>
                                
                                <div className="form-group">
                                    <label>آدرس ایمیل *</label>
                                    <input 
                                        type="email" 
                                        name="email" 
                                        value={formData.email}
                                        onChange={handleChange}
                                        required 
                                    />
                                </div>
                                
                                <div className="form-group">
                                    <label>موضوع *</label>
                                    <input 
                                        type="text" 
                                        name="subject" 
                                        value={formData.subject}
                                        onChange={handleChange}
                                        required 
                                    />
                                </div>
                                
                                <div className="form-group">
                                    <label>متن پیام *</label>
                                    <textarea 
                                        name="message" 
                                        rows="5"
                                        value={formData.message}
                                        onChange={handleChange}
                                        required
                                    ></textarea>
                                </div>
                                
                                <button type="submit" className="btn-submit" disabled={loading}>
                                    {loading ? 'در حال ارسال...' : 'ارسال پیام'}
                                </button>
                            </form>
                        </div>
                        
                        {/* اطلاعات تماس */}
                        <div className="contact-info-card">
                            <h3>اطلاعات تماس</h3>
                            <div className="info-item">
                                <span className="info-icon">📍</span>
                                <div>
                                    <h4>آدرس</h4>
                                    <p>استان : تهران - شهرستان : تهران - بخش : مرکزی - شهر : تهران - محله : تهران نو - خیابان شهید اسماعیل افشاری - کوچه شهید ادوین شامیریان - پلاک : 10.0 - طبقه : 3 - واحد : 7 </p>
                                </div>
                            </div>
                            
                            <div className="info-item">
                                <span className="info-icon">📧</span>
                                <div>
                                    <h4>ایمیل</h4>
                                    <p>info@chekidehsara.com</p>
                                </div>
                            </div>
                            
                            <div className="info-item">
                                <span className="info-icon">📞</span>
                                <div>
                                    <h4>تلفن</h4>
                                    <p>02177920514</p>
                                </div>
                            </div>
                            
                            <div className="info-item">
                                <span className="info-icon">⏰</span>
                                <div>
                                    <h4>ساعات پاسخگویی</h4>
                                    <p>شنبه تا چهارشنبه: 10 صبح تا ۵ عصر</p>
                                </div>
                            </div>
                            
                            <div className="social-links">
                                {/* <h4>شبکه‌های اجتماعی</h4>
                                <div className="social-icons">
                                    <a href="#" target="_blank" rel="noopener noreferrer">📘</a>
                                    <a href="#" target="_blank" rel="noopener noreferrer">📷</a>
                                    <a href="#" target="_blank" rel="noopener noreferrer">🐦</a>
                                    <a href="#" target="_blank" rel="noopener noreferrer">💼</a>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
}

export default Contact;